import { Id } from "@dgs/core";

interface ApplicationBaseResource {
	id: Id;
	type: ApplicationType;
	projectNumber: string;
	subdomain: string;
	setupDate: string;
	deletionDate: string;
}

export interface ApplicationContactStatusResource {
	id: Id;
	subdomain: string;
	status: string | null;
	foreignEntityId: string | null;
}

export enum ApplicationType {
	PARTICIPANT_MANAGEMENT = "PARTICIPANT_MANAGEMENT",
	DEEP = "DEEP",
	KRONOS = "KRONOS",
	CAR_FLEET = "CAR_FLEET",
	MAILCOACH = "MAILCOACH",
}

export interface ApplicationIndexResource extends ApplicationBaseResource {
	id: Id;
}

export interface IApplicationCarFleetResource extends ApplicationBaseResource {
	type: ApplicationType;
	projectNumber: string;
	subdomain: string;
	adminUrl: string;
	apiUrl: string;
}

export interface ParticipantManagementUpdateResource extends ApplicationBaseResource {
	type: ApplicationType.PARTICIPANT_MANAGEMENT;
	configuration: ParticipantManagementApplicationConfiguration;
}

export interface DeepUpdateResource extends ApplicationBaseResource {
	type: ApplicationType.DEEP;
	configuration: DeepApplicationConfiguration;
}

export interface OtherApplicationsUpdateResource extends ApplicationBaseResource {
	type: ApplicationType.CAR_FLEET | ApplicationType.MAILCOACH | ApplicationType.KRONOS;
	configuration: null;
}

export type ApplicationUpdateResource =
	| ParticipantManagementUpdateResource
	| DeepUpdateResource
	| OtherApplicationsUpdateResource;

export interface ApplicationDetailResource extends ApplicationBaseResource {
	domainData: DomainData;
	configuration: Record<string, any>;
}

export interface BaseApplicationFormValues {
	subdomain: string;
	projectNumber: string;
	setupDate: string;
	deletionDate: string;
}

export interface ParticipantManagementUpdateFormValues extends BaseApplicationFormValues {
	configuration: ParticipantManagementApplicationConfiguration;
}

export type ApplicationUpdateFormValues = BaseApplicationFormValues;
export type MailcoachApplicationFormValues = BaseApplicationFormValues;
export type CarFleetApplicationFormValues = BaseApplicationFormValues;

export interface DeepApplicationFormValues extends BaseApplicationFormValues {
	configuration: DeepApplicationConfiguration;
}

export interface ParticipantManagementApplicationFormValues extends BaseApplicationFormValues {
	configuration: ParticipantManagementApplicationConfiguration;
}

export type KronosApplicationFormValues = BaseApplicationFormValues;

export interface BaseApplicationCreateRequest {
	projectNumber: string;
	subdomain: string;
	setupDate: string;
	deletionDate: string;
}

export type MailcoachApplicationCreateRequest = BaseApplicationCreateRequest;
export type CarFleetApplicationCreateRequest = BaseApplicationCreateRequest;

export interface DeepApplicationCreateRequest extends BaseApplicationCreateRequest {
	eventId: Id;
	configuration: DeepApplicationConfiguration;
}

export interface ParticipantManagementApplicationCreateRequest extends BaseApplicationCreateRequest {
	eventId: Id;
	configuration: ParticipantManagementApplicationConfiguration;
}

export interface KronosApplicationCreateRequest extends BaseApplicationCreateRequest {
	eventId: Id;
}

export interface ApplicationUpdateRequest {
	eventId?: Id | undefined;
	subdomain: string;
	projectNumber: string;
	setupDate: string;
	deletionDate: string;
}

export interface ParticipantManagementUpdateRequest extends ApplicationUpdateRequest {
	configuration: ParticipantManagementApplicationConfiguration;
}

export interface ParticipantManagerDomainData {
	frontendUrl: string;
	adminUrl: string;
	nominationManagerUrl: string;
}

export interface DeepKronosDomainData {
	frontendUrl: string;
	adminUrl: string;
	nominationManagerUrl?: undefined;
}

export interface CarFleetMailcoachDomainData {
	frontendUrl?: undefined;
	adminUrl: string;
	nominationManagerUrl?: undefined;
}

export type DomainData = ParticipantManagerDomainData | DeepKronosDomainData | CarFleetMailcoachDomainData;

export interface DeepApplicationConfiguration {
	enableApp: boolean;
	enableFrontend: boolean;
}

export interface ParticipantManagementApplicationConfiguration {
	enableCheckInApp: boolean;
}
